var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-controls",class:{
    isOpen: _vm.isOpen,
  }},[_c('button',{staticClass:"account-controls__button",attrs:{"data-testid":"account-controls-button"},on:{"click":_vm.openDropdown}},[_c('HdIcon',{staticClass:"account-controls__icon",attrs:{"src":_vm.userCircle}})],1),(_vm.isOpen)?_c('HdDropdown',{staticClass:"account-controls__dropdown",attrs:{"items":_vm.dropdownItems},on:{"itemClick":function (ref) {
    var action = ref.action;

    return action();
},"close":_vm.closeDropdown}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }